const darkColors = {
  primary: {
    100: '#61dafb',
  },
  text: {
    white: 'rgb(var(--_content-base-default))',
    primary: 'rgb(var(--_content-base-subdued))',
    dark: 'rgb(var(--_content-flip-default))',
    disabled: '#334155', // --neutral-800*** // could be - var(--neutral-800)
    secondary: 'rgb(var(--accent-primary))',
  },
  background: {
    medium: 'rgb(var(--_background-base-surface-2))',
    dark: 'rgb(var(--_background-base-surface-1))',
    row: 'rgb(var(--_background-base-surface-3))',
    readonly: 'rgb(var(--_input-background-readonly))',
    baseSurface: 'rgb(var(--_background-base-surface-0))',
    baseSurface1: 'rgb(var(--_background-base-surface-1))',
    baseSurface2: 'rgb(var(--_background-base-surface-2))',
    baseSurface3: 'rgb(var(--_background-base-surface-3))',
    primary: '#82F0FF',
  },
  bar: {
    priority1: '#1A4BAB',
    priority2: '#3D79EF',
    priority3: '#96BAFF',
  },
  donut: {
    techCheckedIn: '#82FF91',
    techAssigned: '#9796F3',
    pendingTechAssignment: '#FBB979',
    pendingCustomer: '#FF315E',
    onHold: '#F9CB34',
  },
  stroke: {
    readonly: 'rgb(var(--_stroke-base-default))',
    secondary: '#CBD5E1',
  },
  content: {
    readonly: 'rgb(var(--_content-base-subdued))',
    error: '#FF315E',
  },
  border: {
    light: 'rgb(var(--_stroke-base-heavy))',
    hr: 'rgb(var(--_stroke-base-default))',
    error: '#EC4649',
  },
  button: {
    primary: 'rgb(var(--_button-background-primary-default))',
    primaryHover: 'rgb(var(--_button-background-primary-hover))',
    disabled: 'rgb(var(--_button-background-primary-disabled))',
    hoverColor: 'rgb(var(--_button-content-secondary-hover))',
    tertiary: '#9796f3', // --purple-300*** //could be - var(--purple-300)
    blue: 'rgb(var(--accent-blue))',
  },
  tab: {
    active: '#37808A',
  },
  iconButton: {
    primary: {
      backgroundColor: 'rgb(var(--_button-background-primary-default))',
      color: 'rgb(var(--_button-content-primary-default))',
      hover: 'rgb(var(--_button-background-primary-hover))',
      disabled: 'rgb(var(--_button-background-primary-disabled))',
      active: 'rgb(var(--_button-background-primary-pressed))',
    },
    secondary: {
      borderColor: 'rgb(var(--_button-stroke-secondary-default))',
      color: 'rgb(var(--_button-content-secondary-default))',
      hover: 'rgb(var(--_button-background-secondary-hover))',
      hoverColor: 'rgb(var(--_button-content-secondary-hover))',
      disabled: 'rgb(var(--_button-content-secondary-disabled))',
      active: 'rgb(var(--_button-background-secondary-pressed))',
    },
    destructive: {
      borderColor: '#CBD5E1', // --neutral-400 // var(--_button-content-destructive-default)
      backgroundColor: 'rgb(var(--_button-background-destructive-default))',
      color: 'rgb(var(--_button-content-destructive-default))',
      hover: 'rgb(var(--_button-background-destructive-hover))',
      disabled: 'rgb(var(--_button-background-destructive-disabled))',
      active: 'rgb(var(--_button-background-destructive-pressed))',
    },
    ghost: {
      color: 'rgb(var(--_button-content-ghost-default))',
      hover: 'rgb(var(--_button-content-ghost-hover))',
      disabled: 'rgb(var(--_button-content-ghost-disabled))',
      active: 'rgb(var(-_button-content-ghost-pressed))',
    },
  },
  scroll: {
    background: 'rgb(var(--_background-base-surface-1))',
    thumb: '#94a3b8',
  },
  segment: {
    light: '#82F0FF',
    primary: '#82F0FF',
    tertiary: '#9796f3',
    blue: 'rgb(var(--accent-blue))',
  },
  status: {
    status_success_default: 'rgb(var(--_status-success-default))',
    status_success_subdued: 'rgb(var(--_status-success-subdued))',
    status_error_default: 'rgb(var(--_status-error-default))',
    status_error_subdued: 'rgb(var(--_status-error-subdued))',
    status_warning_default: 'rgb(var(--__status-warning-default))',
    status_warning_subdued: 'rgb(var(--_status-warning-subdued))',
    status_info_default: 'rgb(var(--__status-info-default))',
    status_info_subdued: 'rgb(var(--_status-info-subdued))',
    status_neutral_default: '#222231',
  },
};

const lightColors = {
  primary: {
    100: '#61dafb',
  },
  text: {
    white: 'rgb(var(--_content-base-default))',
    primary: 'rgb(var(--_content-base-subdued))',
    dark: 'rgb(var(--_content-flip-default))',
    disabled: '#334155', // --neutral-800*** // could be - var(--neutral-800)
    secondary: 'rgb(var(--accent-primary))',
  },
  background: {
    medium: 'rgb(var(--_background-base-surface-2))',
    dark: 'rgb(var(--_background-base-surface-1))',
    row: 'rgb(var(--_background-base-surface-3))',
    readonly: 'rgb(var(--_input-background-readonly))',
    baseSurface: 'rgb(var(--_background-base-surface-0))',
    baseSurface1: 'rgb(var(--_background-base-surface-1))',
    baseSurface2: 'rgb(var(--_background-base-surface-2))',
    baseSurface3: 'rgb(var(--_background-base-surface-3))',
    primary: '#82F0FF', // --teal-400*** // could be - var(--teal-400)
  },
  bar: {
    priority1: '#1A4BAB',
    priority2: '#3D79EF',
    priority3: '#96BAFF',
  },
  donut: {
    techCheckedIn: '#82FF91',
    techAssigned: '#9796F3',
    pendingTechAssignment: '#FBB979',
    pendingCustomer: '#FF315E',
    onHold: '#F9CB34',
  },
  stroke: {
    readonly: 'rgb(var(--_stroke-base-default))',
    secondary: 'rgb(203 213 225)', // --neutral-400*** // could be - var(--neutral-400)
  },
  content: {
    readonly: 'rgb(var(--_content-base-subdued))',
    error: '#FF315E', // --red-500*** // could be - var(--purple-300)
  },
  border: {
    light: 'rgb(var(--_stroke-base-heavy))',
    hr: 'rgb(var(--_stroke-base-default))',
    error: 'rgb(236 70 73)', // ***
  },
  button: {
    primary: 'rgb(var(--_button-background-primary-default))',
    primaryHover: 'rgb(var(--_button-background-primary-hover))',
    disabled: 'rgb(var(--_button-background-primary-disabled))',
    hoverColor: 'rgb(var(--_button-content-secondary-hover))',
    tertiary: '#9796f3', // --purple-300*** //could be - var(--purple-300)
    blue: 'rgb(var(--accent-primary))',
  },
  tab: {
    active: 'rgb(55 128 138)', // --teal-700
  },
  scroll: {
    background: 'rgb(var(--_background-base-surface-1))',
    thumb: 'rgb(148 163 184)', // --neutral-900*** could be - var(--_stroke-base-subdued)
  },
  iconButton: {
    primary: {
      backgroundColor: 'rgb(var(--_button-background-primary-default))',
      color: 'rgb(var(--_button-content-primary-default))',
      hover: 'rgb(var(--_button-background-primary-hover))',
      disabled: 'rgb(var(--_button-background-primary-disabled))',
      active: 'rgb(var(--_button-background-primary-pressed))',
    },
    secondary: {
      borderColor: 'rgb(var(--_button-stroke-secondary-default))',
      color: 'rgb(var(--_button-content-secondary-default))',
      hover: 'rgb(var(--_button-background-secondary-hover))',
      hoverColor: 'rgb(var(--_button-content-secondary-hover))',
      disabled: 'rgb(var(--_button-content-secondary-disabled))',
      active: 'rgb(var(--_button-background-secondary-pressed))',
    },
    destructive: {
      borderColor: '#CBD5E1', // --neutral-400 // var(--_button-content-destructive-default)
      backgroundColor: 'rgb(var(--_button-background-destructive-default))',
      color: 'rgb(var(--_button-content-destructive-default))',
      hover: 'rgb(var(--_button-background-destructive-hover))',
      disabled: 'rgb(var(--_button-background-destructive-disabled))',
      active: 'rgb(var(--_button-background-destructive-pressed))',
    },
    ghost: {
      color: 'rgb(var(--_button-content-ghost-default))',
      hover: 'rgb(var(--_button-content-ghost-hover))',
      disabled: 'rgb(var(--_button-content-ghost-disabled))',
      active: 'rgb(var(-_button-content-ghost-pressed))',
    },
  },
  segment: {
    light: 'rgb(130 240 255)', // --teal-400*** // could be - var(--_stroke-accent-default)
    primary: 'rgb(130 240 255)', // --teal-400*** // could be - var(--_stroke-accent-default)
    tertiary: 'rgb(151 150 243)', // --purple-300*** // could be - var(--purple-300)
    blue: 'rgb(108 157 255)', // --accent-primary*** // could be - var(--accent-primary)
  },
  status: {
    status_success_default: 'rgb(var(--_status-success-default))',
    status_success_subdued: 'rgb(var(--_status-success-subdued))',
    status_error_default: 'rgb(var(--_status-error-default))',
    status_error_subdued: 'rgb(var(--_status-error-subdued))',
    status_warning_default: 'rgb(var(--__status-warning-default))',
    status_warning_subdued: 'rgb(var(--_status-warning-subdued))',
    status_info_default: 'rgb(var(--__status-info-default))',
    status_info_subdued: 'rgb(var(--_status-info-subdued))',
    status_neutral_default: '#222231', // --blue-800***
  },
};

const text = {
  size: {
    '2xs': '8px',
    xs: '10px',
    sm: '12px',
    md: '14px',
    lg: '16px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '28px',
    '4xl': '40px',
    '5xl': '52px',
  },
};

const heading = {
  size: {
    '3xl': '44px',
    '2xl': '36px',
    xl: '32px',
    lg: '28px',
    sm: '20px',
    md: '24px',
    xs: '16px',
  },
};

const spacing = {
  factorOf: (factor: number) => {
    const defaultSpacing = 4;
    return `${factor * defaultSpacing}px`;
  },
};

const breakpoints = {
  mobile: 375,
  tablet: 768,
};

const media = `@media (max-width: ${breakpoints.tablet}px)`;

const fonts = {
  body: 'var(--font-family-sans), sans-serif',
  heading: 'var(--font-family-sans), sans-serif',
  special: 'Helvetica, serif',
};

const fontWeights = {
  bold: 600,
  semibold: 500,
  medium: 400,
  regular: 300,
};

const customTheme = {
  text,
  spacing,
  breakpoints,
  media,
  fonts,
  fontWeights,
  heading,
  lightColors,
  darkColors,
  // default
  color: darkColors,
};

export default customTheme;
